/* Sola Wear (van Zeyna London) — doorlopende announcement bar (marquee) met pauze/afspeel-knop.
   Markup + CSS: sections/header-announcements.liquid.
   De groep meldingen wordt gekloond tot de strook breder is dan het scherm;
   de strook schuift precies één groepbreedte op en begint dan naadloos opnieuw. */
(function () {
  'use strict';
  if (!window.customElements || customElements.get('zl-marquee')) return;

  var reduceMotion = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  class ZlMarquee extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.zl-mq__viewport');
      this.track = this.querySelector('.zl-mq__track');
      this.group = this.querySelector('.zl-mq__group');
      this.btn = this.querySelector('.zl-mq__toggle');
      if (!this.viewport || !this.track || !this.group || !this.group.children.length) return;

      this.speed = Math.max(4, parseFloat(this.getAttribute('data-speed')) || 40); // px per seconde
      this.lastW = 0;
      this.lastV = 0;

      if (this.btn) {
        this.btn.hidden = false;
        this.onToggle = this.toggle.bind(this);
        this.btn.addEventListener('click', this.onToggle);
      }
      // Wie minder beweging wil, krijgt de balk stilstaand (en kan zelf op play drukken).
      if (reduceMotion) this.setPaused(true);

      this.build();
      if (window.ResizeObserver) {
        this.ro = new ResizeObserver(this.build.bind(this));
        this.ro.observe(this.viewport);
        this.ro.observe(this.group);
      }
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.build.bind(this));
    }

    disconnectedCallback() {
      if (this.ro) this.ro.disconnect();
      if (this.btn && this.onToggle) this.btn.removeEventListener('click', this.onToggle);
    }

    build() {
      var w = this.group.getBoundingClientRect().width;
      var v = this.viewport.getBoundingClientRect().width;
      if (!w || !v) return;
      if (Math.abs(w - this.lastW) < 0.5 && Math.abs(v - this.lastV) < 0.5) return;
      this.lastW = w;
      this.lastV = v;

      var clones = this.track.querySelectorAll('[data-zl-clone]');
      for (var i = 0; i < clones.length; i++) clones[i].remove();

      // Genoeg kopieën zodat er tijdens één groepbreedte verschuiven nooit een gat valt.
      var need = Math.ceil(v / w);
      for (var n = 0; n < need; n++) {
        var c = this.group.cloneNode(true);
        c.setAttribute('data-zl-clone', '');
        c.setAttribute('aria-hidden', 'true');
        var marked = c.querySelectorAll('[data-shopify-editor-block]');
        for (var m = 0; m < marked.length; m++) marked[m].removeAttribute('data-shopify-editor-block');
        var links = c.querySelectorAll('a, button');
        for (var l = 0; l < links.length; l++) links[l].setAttribute('tabindex', '-1');
        this.track.appendChild(c);
      }

      this.style.setProperty('--zl-mq-shift', w + 'px');
      this.style.setProperty('--zl-mq-dur', (w / this.speed).toFixed(2) + 's');
      this.classList.add('is-ready');
    }

    setPaused(paused) {
      this.classList.toggle('is-paused', paused);
      if (this.btn) {
        this.btn.setAttribute('aria-label', this.btn.getAttribute(paused ? 'data-label-play' : 'data-label-pause'));
      }
    }

    toggle() {
      this.setPaused(!this.classList.contains('is-paused'));
    }
  }

  customElements.define('zl-marquee', ZlMarquee);
})();
